import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AuditlogService } from '../services/auditlog';

export const auditlogResolver: ResolveFn<void> = async (route, state) => {
  const auditService = inject(AuditlogService);
  return await auditService.list();
};
